/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './procedure-investigation.reducer';

export const ProcedureInvestigationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const procedureInvestigationEntity = useAppSelector(state => state.procedureInvestigation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="procedureInvestigationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.procedureInvestigation.detail.title">ProcedureInvestigation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.procedureInvestigation.id">Id</Translate>
            </span>
          </dt>
          <dd>{procedureInvestigationEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.procedureInvestigation.active">Active</Translate>
            </span>
          </dt>
          <dd>{procedureInvestigationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.procedureInvestigation.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{procedureInvestigationEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.procedureInvestigation.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{procedureInvestigationEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.procedureInvestigation.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{procedureInvestigationEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.procedureInvestigation.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{procedureInvestigationEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.procedureInvestigation.test">Test</Translate>
          </dt>
          <dd>{procedureInvestigationEntity.test ? procedureInvestigationEntity.test.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.procedureInvestigation.procedure">Procedure</Translate>
          </dt>
          <dd>{procedureInvestigationEntity.procedure ? procedureInvestigationEntity.procedure.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/procedure-investigation" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/procedure-investigation/${procedureInvestigationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ProcedureInvestigationDetail;
